module.exports = __webpack_public_path__ + "static/media/brands.8c11d802.png";